import React, { useEffect, useRef, useState } from "react";
import ResponsiveDrawer from "../../component/sidebar/sidebar.component";
import { apiErrorMessage } from "../../helper/apiError";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontWeight } from "../../component/theme/fontWeight";
import { fontSize } from "../../component/theme/fontSize";
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  FormGroup,
  Grid,
  IconButton,
  Modal,
  Stack,
  TextField,
  Typography,
  createSvgIcon,
  styled,
} from "@mui/material";
import { ThemeColor } from "../../component/theme/color";
import OutlinedInputField from "../../component/inputfiled/OutlinedInput";
import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import OutlinedTextAreaField from "../../component/inputfiled/OutlinedTextedArea";
import AddIcon from "@mui/icons-material/Add";
import * as Yup from "yup";
import MyDatePicker from "../../component/datepicker/OutlinedDatepicker";
import dayjs from "dayjs";
import CustomButton from "../../component/button/button";
import "../mail/mail.css";
import Tempautocomplete from "../../component/autocomplete/Tempautocomplete";
import Delete from "../../Icon/Delete";
import Crossicon from "../../Icon/Crossicon";
import AutocompleteWithRadio from "../../component/autocomplete/Tempautocomplete";
import { List } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import CloseIcon from "@mui/icons-material/Close";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import {
  convertToRaw,
  convertFromHTML,
  ContentState,
  EditorState,
} from "draft-js";
import {
  AddEmailTemplateService,
  EditEmailTemplateService,
} from "../../Redux/service/MailService";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

const NoPaddingGridItem = styled(Grid)({
  paddingTop: "0px !important",
});

const style = {
  position: "absolute",
  top: "30%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid grey",
  boxShadow: 24,
  p: 4,
};

const AddNewMailTemplatePage = () => {
  const dispatch = useDispatch();
  const childRef = useRef(null);
  const formikRef = useRef(null);
  const navigate = useNavigate();

  const [open, setOpen] = React.useState(false);

  const [selections, setSelections] = useState([]);
  const [formLoading, setFormLoading] = useState(false);

  const [value, setValue] = useState("simple text");

  const [b_description, setB_Description] = useState();

  const [editorState, setEditorState] = useState("");

  const [scheduleState, setScheduleState] = useState(false);
  const [reminderdatatime, setReminderdatatime] = useState();
  const [schedulesubmitted, setSchedulesubmitted] = useState(false);
  const [attachments, setAttachments] = useState();
  const auth =
    "eyJ0eXAiOiJKV1QiLCJub25jZSI6Ik4zNHFrcDVRYUhvWXMyV0pQMlhjall3blMybXNTZFNKc08zaFY5ekJEclEiLCJhbGciOiJSUzI1NiIsIng1dCI6Ikg5bmo1QU9Tc3dNcGhnMVNGeDdqYVYtbEI5dyIsImtpZCI6Ikg5bmo1QU9Tc3dNcGhnMVNGeDdqYVYtbEI5dyJ9.eyJhdWQiOiIwMDAwMDAwMy0wMDAwLTAwMDAtYzAwMC0wMDAwMDAwMDAwMDAiLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC82MmU3NGMyNC1iN2JjLTQ3NDYtYTNjMS1hZGRkMjUwZTE5MWQvIiwiaWF0IjoxNzI1NTE3ODg4LCJuYmYiOjE3MjU1MTc4ODgsImV4cCI6MTcyNTUyMzU4NywiYWNjdCI6MCwiYWNyIjoiMSIsImFpbyI6IkFUUUF5LzhYQUFBQTNSTzZ2RjVuZ09ydGorWllJY0RFMnZ4ZTdOcWVLOHprdVRnRUYvZnM0WktrZkF1NE53cytMd2pCelJ0U211bzQiLCJhbXIiOlsicHdkIl0sImFwcF9kaXNwbGF5bmFtZSI6ImNhZUNSTSIsImFwcGlkIjoiYmQxMDlhZmUtZmJkMi00NDE3LTk2MDUtMjFlMGYxZTYzZTMwIiwiYXBwaWRhY3IiOiIxIiwiZmFtaWx5X25hbWUiOiJQYW5kZXkiLCJnaXZlbl9uYW1lIjoiQmlwdW5kIiwiaWR0eXAiOiJ1c2VyIiwiaXBhZGRyIjoiMjQwMTo0OTAwOjUxZDg6ZDUxMTpkMDI2OjJmMDU6YWMwZjphY2Q4IiwibmFtZSI6IkJpcHVuZCBQYW5kZXkiLCJvaWQiOiJlOGVkNWQ3Yy05MGRkLTQyMmItYjIwMC0wNGE2YjcxN2MwYTciLCJwbGF0ZiI6IjMiLCJwdWlkIjoiMTAwMzIwMDJBMTEzRTUyNyIsInJoIjoiMC5BWEVBSkV6bllyeTNSa2Vqd2EzZEpRNFpIUU1BQUFBQUFBQUF3QUFBQUFBQUFBQ0hBR3cuIiwic2NwIjoiZW1haWwgTWFpbC5SZWFkIE1haWwuU2VuZCBvcGVuaWQgcHJvZmlsZSBVc2VyLlJlYWQiLCJzaWduaW5fc3RhdGUiOlsia21zaSJdLCJzdWIiOiJOQWFjeFc2c01WMnlUM0xueTBZTDZMcUphUXJJTzBqT1NqVm93YS1uY0dnIiwidGVuYW50X3JlZ2lvbl9zY29wZSI6IkFTIiwidGlkIjoiNjJlNzRjMjQtYjdiYy00NzQ2LWEzYzEtYWRkZDI1MGUxOTFkIiwidW5pcXVlX25hbWUiOiJCaXB1bmRAcGNvZGVydGVjaG5vbG9naWVzLnVzIiwidXBuIjoiQmlwdW5kQHBjb2RlcnRlY2hub2xvZ2llcy51cyIsInV0aSI6IkdIdmctRTlGTkVLRkdNREZSWGhCQVEiLCJ2ZXIiOiIxLjAiLCJ3aWRzIjpbIjY5MDkxMjQ2LTIwZTgtNGE1Ni1hYTRkLTA2NjA3NWIyYTdhOCIsImYyZWY5OTJjLTNhZmItNDZiOS1iN2NmLWExMjZlZTc0YzQ1MSIsIjI5MjMyY2RmLTkzMjMtNDJmZC1hZGUyLTFkMDk3YWYzZTRkZSIsImZlOTMwYmU3LTVlNjItNDdkYi05MWFmLTk4YzNhNDlhMzhiMSIsImYwMjNmZDgxLWE2MzctNGI1Ni05NWZkLTc5MWFjMDIyNjAzMyIsIjYyZTkwMzk0LTY5ZjUtNDIzNy05MTkwLTAxMjE3NzE0NWUxMCIsImYyOGExZjUwLWY2ZTctNDU3MS04MThiLTZhMTJmMmFmNmI2YyIsIjcyOTgyN2UzLTljMTQtNDlmNy1iYjFiLTk2MDhmMTU2YmJiOCIsImI3OWZiZjRkLTNlZjktNDY4OS04MTQzLTc2YjE5NGU4NTUwOSJdLCJ4bXNfaWRyZWwiOiIxIDE0IiwieG1zX3N0Ijp7InN1YiI6IlN3czZ5Ri1Ja05ueG10eHhLQ3ZrZG5lZDRaZDVpNWNpaklzN1hmSzFscHMifSwieG1zX3RjZHQiOjE2NTYzMjA3OTl9.JLkyfajYwM0eidirQI-Lz96le0yEYJG8bs9r4yjIqqMc1p1NHOqxCGj6Y0exx-J1uduXoKBC32vnEhLRZx8HDVkuDVky5axHOvOSrXRag_KTOENCqdLJrONAkv1eljkHd7WR_i_DIo5TFXOPKx31RoCU2KZTfmn_CAElwYvjHUEVTQ1kFzgAeF0b_d3N9Cv2eICyvO-S97pXmtThee1ce9ex-ADNq2cZ0m_1yLRdK2Ndw-GX1gJyAKJBw5Gb8omYPq_qm6oQaMeWP4Mvyx6EQthfG60BJwK0I9gDZLvcSJw9ui_Cn45kE7892MTvp4I5syg1VLm2ULQV_9L0coPWDg";

  const { id } = useParams();

  const [Edit, setEdit] = useState(id ? true : false);

  const [prefieldData, setPrefieldData] = useState();

  const [roleEdit, setRoleEdit] = useState([]);

  const EditEmailTemplatedataState = useSelector(
    (state) => state.email?.emailTemplate?.data?.emailTemplates
  );
  //(EditEmailTemplatedataState);
  useEffect(() => {
    setPrefieldData(
      EditEmailTemplatedataState?.filter((data) => data._id === id)?.[0]
    );


    if (Edit) {
      // Convert HTML to Draft's ContentState
      const blocksFromHTML = convertFromHTML(EditEmailTemplatedataState?.filter((data) => data._id === id)?.[0]?.body);
      const contentState = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      setEditorState(EditorState.createWithContent(contentState));
    }

    
  }, [Edit, EditEmailTemplatedataState, id]);

  const handleClose = () => setOpen(false);
  const handleReminderSave = () => {
    setOpen(false);
    if (reminderdatatime != null) {
      handleFromSubmit(formikRef.current.values, "schedule_send_mail");
    }
  };

  const handleSelectionChange = (newSelections) => {
    setSelections(newSelections);
  };

  const handleDelete = (name) => {
    setSelections((prevSelections) =>
      prevSelections.filter((selection) => selection.name !== name)
    );
  };

  const validationSchema = Yup.object().shape({
    subject: Yup.string().required("Subject Of email in template is required."),
    templateName: Yup.string().required("Template name is required."),
    body: Yup.string().required("Body for template is reuqired is required."),
  });

  function convertImagesToBase64(imagesArray) {
    const promises = imagesArray.map((image) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        // Convert image to base64 string when loaded
        reader.onload = () =>
          resolve({ name: image.name, base64: reader.result });
        // reader.onload = () => resolve(reader.result);

        // Handle errors
        reader.onerror = () =>
          reject(new Error("Error converting image to base64"));

        // Read the image as a data URL (base64)
        reader.readAsDataURL(image);
      });
    });

    // Return a promise that resolves when all images are converted
    return Promise.all(promises);
  }

  const handleFromSubmit = async (values, type) => {
    if (!Edit) {
      await AddEmailTemplateService(values)
        .then((res) => {
          if (res.status === 200) {
            // //(res);
            setFormLoading(false);

            dispatch(showSnackbar(res.data.message, "success"));

            navigate("/CAE/emailTemplatelist");
          }
        })
        .catch((e) => {
          setFormLoading(false);
          dispatch(showSnackbar(apiErrorMessage(e), "error"));
        });
    } else {
      await EditEmailTemplateService(id, values)
        .then((res) => {
          if (res.status === 200) {
            // //(res);
            setFormLoading(false);

            dispatch(showSnackbar(res.data.message, "success"));

            navigate("/CAE/emailTemplatelist");
          }
        })
        .catch((e) => {
          setFormLoading(false);
          dispatch(showSnackbar(apiErrorMessage(e), "error"));
        });
    }
  };

  if (!prefieldData && Edit) {
    return (
      <div className="w-100 h-100 d-flex justify-content-center align-items-center">
        <CircularProgress color="inherit" />
      </div>
    ); // You can replace this with a loading spinner
  }
  return (
    <>
      <Grid container spacing={2}>
        <Grid item lg={8} xs={12}>
          <div className="d-flex align-items-center">
            <Typography
              fontFamily={FontFamily.Poppins}
              fontWeight={fontWeight.W600}
              fontSize={fontSize.h2.small}
            >
              Send Mail
            </Typography>
            <Typography
              className="px-2 pt-1"
              fontFamily={FontFamily.Poppins}
              fontSize={fontSize.h4.medium}
              fontWeight={fontWeight.W300}
              color={ThemeColor.GREY}
            >
              create a new mail
            </Typography>
          </div>
        </Grid>
      </Grid>
      <div className="container">
        <Formik
          innerRef={formikRef}
          initialValues={{
            templateName: Edit ? prefieldData?.templateName : "",
            subject: Edit ? prefieldData?.subject : "",
            body: Edit ? convertFromHTML(prefieldData?.body) : "",
          }}
          validationSchema={validationSchema}
          onSubmit={async (values) => {
            //("Form data:", values);

            handleFromSubmit(values, "send_mail");
          }}
        >
          {({
            values,
            errors,
            handleBlur,
            handleChange,
            touched,
            handleSubmit,
            setFieldValue,
          }) => (
            <Form className="" onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                {/* grid for right basic content */}
                <Grid item lg={12}>
                  <Typography
                    align="center"
                    fontFamily={FontFamily.Poppins}
                    fontWeight={fontWeight.W600}
                    fontSize={fontSize.h3.medium}
                    color={ThemeColor.PURPLE}
                  >
                    New Mail Template
                  </Typography>
                </Grid>

                <Grid item lg={12}>
                  <NoPaddingGridItem item lg={12} md={12} sm={12} xs={12}>
                    <FormGroup style={{}}>
                      <div className="">
                        <Typography
                          className="mb-2"
                          fontFamily={FontFamily.Lato}
                          fontSize={fontSize.h3.medium}
                          fontWeight={fontWeight.W400}
                        >
                          Template Name
                        </Typography>
                        <OutlinedInputField
                          value={values.templateName}
                          onChange={handleChange}
                          name={"templateName"}
                          placeholder="Enter template name...."
                          fullWidth={true}
                          helperText={
                            <Typography
                              align="left"
                              // className="px-3"
                              color={ThemeColor.RED}
                              fontSize={fontSize.h4.medium}
                              fontFamily={FontFamily.Lato}
                              fontWeight={fontWeight.W500}
                            >
                              {errors.templateName}
                            </Typography>
                          }
                        />
                      </div>
                    </FormGroup>
                  </NoPaddingGridItem>
                  <NoPaddingGridItem item lg={12} md={12} sm={12} xs={12}>
                    <FormGroup style={{}}>
                      <div className="">
                        <Typography
                          className="mb-2"
                          fontFamily={FontFamily.Lato}
                          fontSize={fontSize.h3.medium}
                          fontWeight={fontWeight.W400}
                        >
                          Subject
                        </Typography>
                        <OutlinedInputField
                          value={values.subject}
                          onChange={handleChange}
                          name={"subject"}
                          placeholder="Enter subject"
                          fullWidth={true}
                          helperText={
                            <Typography
                              align="left"
                              // className="px-3"
                              color={ThemeColor.RED}
                              fontSize={fontSize.h4.medium}
                              fontFamily={FontFamily.Lato}
                              fontWeight={fontWeight.W500}
                            >
                              {errors.subject}
                            </Typography>
                          }
                        />
                      </div>
                    </FormGroup>
                  </NoPaddingGridItem>
                  <NoPaddingGridItem item lg={12} md={12} sm={12} xs={12}>
                    <FormGroup style={{}}>
                      <div className="">
                        <Typography
                          className="mb-2"
                          fontFamily={FontFamily.Lato}
                          fontSize={fontSize.h3.medium}
                          fontWeight={fontWeight.W400}
                        >
                          Add Mail Body
                        </Typography>
                        <Editor
                          editorState={editorState}
                          toolbarClassName="toolbarClassName"
                          wrapperClassName="wrapperClassName"
                          editorClassName="editorClassName"
                          placeholder="Start your mail......"
                          style={{ backgrond: "white" }}  
                          toolbar={{
                            options: [
                              "inline",
                              "blockType",
                              "fontSize",
                              "fontFamily",
                              "list",
                              "textAlign",
                              "colorPicker",
                              "link",
                              "embedded",
                              "emoji",
                              "image",
                              "remove",
                              "history",
                            ],
                            inline: {
                              inDropdown: false,
                              className: undefined,
                              component: undefined,
                              dropdownClassName: undefined,
                              options: [
                                "bold",
                                "italic",
                                "underline",
                                "strikethrough",
                                "monospace",
                                "superscript",
                                "subscript",
                              ],
                              //   bold: { icon: bold, className: undefined },
                            },
                            blockType: {
                              inDropdown: false,
                              options: [
                                "Normal",
                                "H1",
                                "H2",
                                "H3",
                                "H4",
                                "H5",
                                "H6",
                                "Blockquote",
                                "Code",
                              ],
                              className: undefined,
                              component: undefined,
                              dropdownClassName: undefined,
                            },
                            fontSize: {
                              //   icon: fontSize,
                              inDropdown: true,
                              options: [
                                8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48,
                                60, 72, 96,
                              ],
                              className: undefined,
                              component: undefined,
                              dropdownClassName: undefined,
                            },
                            fontFamily: {
                              options: [
                                "Arial",
                                "Georgia",
                                "Impact",
                                "Tahoma",
                                "Times New Roman",
                                "Verdana",
                              ],
                              className: undefined,
                              component: undefined,
                              dropdownClassName: undefined,
                            },
                            list: {
                              inDropdown: false,
                              className: undefined,
                              component: undefined,
                              dropdownClassName: undefined,
                              options: [
                                "unordered",
                                "ordered",
                                "indent",
                                "outdent",
                              ],
                            },
                            textAlign: {
                              inDropdown: false,
                              className: undefined,
                              component: undefined,
                              dropdownClassName: undefined,
                              options: ["left", "center", "right", "justify"],
                            },

                            link: {
                              inDropdown: false,
                              className: undefined,
                              component: undefined,
                              popupClassName: undefined,
                              dropdownClassName: undefined,
                              showOpenOptionOnHover: true,
                              defaultTargetOption: "_self",
                              options: ["link", "unlink"],
                              linkCallback: undefined,
                            },
                            emoji: {
                              className: undefined,
                              component: undefined,
                              popupClassName: undefined,
                              emojis: [
                                "😀",
                                "😁",
                                "😂",
                                "😃",
                                "😉",
                                "😋",
                                "😎",
                                "😍",
                                "😗",
                                "🤗",
                                "🤔",
                                "😣",
                                "😫",
                                "😴",
                                "😌",
                                "🤓",
                                "😛",
                                "😜",
                                "😠",
                                "😇",
                                "😷",
                                "😈",
                                "👻",
                                "😺",
                                "😸",
                                "😹",
                                "😻",
                                "😼",
                                "😽",
                                "🙀",
                                "🙈",
                                "🙉",
                                "🙊",
                                "👼",
                                "👮",
                                "🕵",
                                "💂",
                                "👳",
                                "🎅",
                                "👸",
                                "👰",
                                "👲",
                                "🙍",
                                "🙇",
                                "🚶",
                                "🏃",
                                "💃",
                                "⛷",
                                "🏂",
                                "🏌",
                                "🏄",
                                "🚣",
                                "🏊",
                                "⛹",
                                "🏋",
                                "🚴",
                                "👫",
                                "💪",
                                "👈",
                                "👉",
                                "👉",
                                "👆",
                                "🖕",
                                "👇",
                                "🖖",
                                "🤘",
                                "🖐",
                                "👌",
                                "👍",
                                "👎",
                                "✊",
                                "👊",
                                "👏",
                                "🙌",
                                "🙏",
                                "🐵",
                                "🐶",
                                "🐇",
                                "🐥",
                                "🐸",
                                "🐌",
                                "🐛",
                                "🐜",
                                "🐝",
                                "🍉",
                                "🍄",
                                "🍔",
                                "🍤",
                                "🍨",
                                "🍪",
                                "🎂",
                                "🍰",
                                "🍾",
                                "🍷",
                                "🍸",
                                "🍺",
                                "🌍",
                                "🚑",
                                "⏰",
                                "🌙",
                                "🌝",
                                "🌞",
                                "⭐",
                                "🌟",
                                "🌠",
                                "🌨",
                                "🌩",
                                "⛄",
                                "🔥",
                                "🎄",
                                "🎈",
                                "🎉",
                                "🎊",
                                "🎁",
                                "🎗",
                                "🏀",
                                "🏈",
                                "🎲",
                                "🔇",
                                "🔈",
                                "📣",
                                "🔔",
                                "🎵",
                                "🎷",
                                "💰",
                                "🖊",
                                "📅",
                                "✅",
                                "❎",
                                "💯",
                              ],
                            },
                            embedded: {
                              className: undefined,
                              component: undefined,
                              popupClassName: undefined,
                              embedCallback: undefined,
                              defaultSize: {
                                height: "auto",
                                width: "auto",
                              },
                            },

                            remove: {
                              className: undefined,
                              component: undefined,
                            },
                            history: {
                              inDropdown: false,
                              className: undefined,
                              component: undefined,
                              dropdownClassName: undefined,
                              options: ["undo", "redo"],
                            },
                          }}
                          editorStyle={{
                            color: "#164242",
                            background: "white",
                          }}
                          onEditorStateChange={(e) => {
                            //(e);
                            setEditorState(e);
                          }}
                          onChange={(e) => {
                            setB_Description(
                              draftToHtml(
                                convertToRaw(editorState.getCurrentContent())
                              )
                            );
                            setFieldValue(
                              "body",
                              draftToHtml(
                                convertToRaw(editorState.getCurrentContent())
                              )
                            );
                          }}
                        />
                        <Typography
                          align="left"
                          // className="px-3"
                          color={ThemeColor.RED}
                          fontSize={fontSize.h4.medium}
                          fontFamily={FontFamily.Lato}
                          fontWeight={fontWeight.W500}
                        >
                          {errors?.body}
                        </Typography>
                      </div>
                    </FormGroup>
                  </NoPaddingGridItem>
                </Grid>

                {/* grid for left docs uploading content */}
                {/* <Grid item lg={4}>
                  <div className="w-100 d-flex justify-content-center align-items-center h-100">
                    <Previews
                      // handleMydropzoneFile={(updatedFiles) => {
                      //   //(updatedFiles);
                      //   setFieldValue("attachments", updatedFiles);

                      // }}

                      ref={childRef}
                      initialValue={values?.attachments}
                      handleMydropzoneFile={(updatedFiles) => {
                        // //(updatedFiles, "oooyesah");
                        setFieldValue("attachments", updatedFiles);
                      }}
                    />
                  </div>
                </Grid> */}
              </Grid>
              <Box
                className="w-100 mt-5"
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: {
                    sm: "column",
                    xs: "column",
                    lg: "row",
                    md: "row",
                  },
                }}
              >
                <div>
                  <CustomButton
                    variant="contained"
                    type="submit"
                    backgroundColor={ThemeColor.PURPLE}
                    color={ThemeColor.WHITE}
                    loading={formLoading}
                    //   padding={"0px"}
                    onClick={(e) => setScheduleState(false)}
                  >
                    Add Template
                  </CustomButton>
                </div>
              </Box>
            </Form>
          )}
        </Formik>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <FormGroup style={{}}>
              <div className="">
                <Typography
                  className="mb-2"
                  fontFamily={FontFamily.Lato}
                  fontSize={fontSize.h3.medium}
                  fontWeight={fontWeight.W400}
                >
                  Reminder Date & Time
                </Typography>
                <MyDatePicker
                  minDate={dayjs().startOf("day")}
                  label="Enter Reminder Date & Time"
                  // value={reminderdatatime}
                  onChange={(date) => {
                    setReminderdatatime(dayjs(date).format("YYYY-MM-DD HH:MM"));
                  }}
                />
                <Box className="mt-3" sx={{}}>
                  <CustomButton
                    variant="contained"
                    // type="submit"
                    backgroundColor={ThemeColor.PURPLE}
                    color={ThemeColor.WHITE}
                    //   padding={"0px"}
                    onClick={handleReminderSave}
                  >
                    Save & Send
                  </CustomButton>
                </Box>
              </div>
            </FormGroup>
          </Box>
        </Modal>
      </div>
    </>
  );
};

function AddNewMailTemplate() {
  return (
    <div>
      <ResponsiveDrawer maincontent={<AddNewMailTemplatePage />} />
    </div>
  );
}

export default AddNewMailTemplate;
